import { useContext } from "react";
import { useLocation } from "react-router-dom";

import ResumeContext from "../context/ResumeContext/index";
import { extrasRoutes } from "../router/extrasRoutes";

const useExtrasnav = () => {
	const location = useLocation();
	const { resumeData } = useContext(ResumeContext);
	const { references, selectedExtras } = resumeData.extras;

	if (location.pathname === "/resume/reference-summary" && references.length === 0) {
		return "/resume/reference-information";
	}

	const enabledPaths = extrasRoutes
		.filter(({ key }) => (key === "customExtra" ? selectedExtras.customExtra !== "" : Boolean(selectedExtras[key])))
		.map(({ key, path }) => (key === "customExtra" ? `/resume/custom-extra/${selectedExtras.customExtra}` : path));
	const currentIndex = enabledPaths.findIndex((path) => path === location.pathname);

	return enabledPaths[currentIndex + 1] ?? "/resume/review";
};

export default useExtrasnav;
